/**
 * 矢羽根型の手順表示 (1 読み取り → 2 反映 など)。動画エディターの AIディレクターのステッパーと同じ形。
 * 案件の URL 読み取りパネルとブランド新規作成モーダルで共用する (2026-10-30 にパネルから切り出し)。
 * onSelect を渡すと各段がボタンになり (前後に移れる)、渡さなければ表示だけ。
 */
import './ArrowSteps.css';

export interface ArrowStep {
  value: number;
  label: string;
  /** 押せない段 (onSelect があるときだけ効く) */
  disabled?: boolean;
}

interface Props {
  steps: ReadonlyArray<ArrowStep>;
  current: number;
  ariaLabel: string;
  onSelect?: (value: number) => void;
  /** 並びの幅・余白など置き場所ごとの指定 */
  className?: string;
}

export function ArrowSteps({ steps, current, ariaLabel, onSelect, className }: Props) {
  return (
    <ol className={`arrow-steps${className ? ` ${className}` : ''}`} aria-label={ariaLabel}>
      {steps.map(({ value, label, disabled }) => {
        const cls = `arrow-step${value === current ? ' is-active' : ''}${value < current ? ' is-done' : ''}`;
        const content = (
          <>
            <span className="arrow-step-index" aria-hidden="true">{value}</span>
            <span>{label}</span>
          </>
        );
        return (
          <li key={value}>
            {onSelect ? (
              <button
                type="button"
                className={cls}
                aria-current={value === current ? 'step' : undefined}
                aria-label={`ステップ${value}: ${label}`}
                disabled={disabled}
                onClick={() => onSelect(value)}
              >
                {content}
              </button>
            ) : (
              <span className={`${cls} is-static`} aria-current={value === current ? 'step' : undefined}>
                {content}
              </span>
            )}
          </li>
        );
      })}
    </ol>
  );
}
